var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.25 387.188C149.372 387.188 164.062 372.497 164.062 354.375C164.062 336.253 149.372 321.562 131.25 321.562C113.128 321.562 98.4375 336.253 98.4375 354.375C98.4375 372.497 113.128 387.188 131.25 387.188Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.875 387.188C319.997 387.188 334.688 372.497 334.688 354.375C334.688 336.253 319.997 321.562 301.875 321.562C283.753 321.562 269.062 336.253 269.062 354.375C269.062 372.497 283.753 387.188 301.875 387.188Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3751 118.125H363.75L324.19 256.586C322.623 262.071 319.311 266.897 314.757 270.332C310.203 273.767 304.654 275.625 298.95 275.625H134.175C128.471 275.625 122.922 273.767 118.368 270.332C113.814 266.896 110.503 262.071 108.935 256.586L53.3448 62.0193C52.5612 59.2768 50.9057 56.8643 48.6286 55.1467C46.3516 53.4291 43.577 52.5 40.7248 52.5H19.6875",
    stroke: "currentColor",
    strokeWidth: 21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.784 83.0721C219.784 88.4665 215.411 92.8395 210.016 92.8395C204.622 92.8395 200.249 88.4665 200.249 83.0721V24.4675C200.249 19.073 204.622 14.7 210.016 14.7C215.411 14.7 219.784 19.073 219.784 24.4675V83.0721ZM166.456 77.5715C168.736 82.4605 166.62 88.2719 161.731 90.5517C156.842 92.8315 151.031 90.7163 148.751 85.8273L136.367 59.2704C134.088 54.3814 136.203 48.5699 141.092 46.2902C145.981 44.0104 151.792 46.1256 154.072 51.0146L166.456 77.5715ZM271.281 85.8273C269.002 90.7163 263.19 92.8315 258.301 90.5517C253.412 88.2719 251.297 82.4605 253.577 77.5715L265.96 51.0146C268.24 46.1256 274.052 44.0104 278.941 46.2902C283.83 48.5699 285.945 54.3814 283.665 59.2704L271.281 85.8273Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.7280d55f6e4c551c392c6663dac4f1ae.svg";
export { ForwardRef as ReactComponent };